import { object, string, TypeOf } from 'zod';

/* ------------------------------ ProductPerson ----------------------------- */

export const ProductPerson = object({
    personId: string(),
    personTypeId: string(),
    role: string().optional(),
});

export type ProductPerson = TypeOf<typeof ProductPerson>;
